import React from 'react';
import { BookOpen, CheckCircle2 } from 'lucide-react';
export function IncludesSection() {
  const guides = [{
    title: 'Tomo 1 – Fundamentos del Detailing Automotriz',
    description: 'Aprende las bases, la diferencia entre lavado tradicional y detailing, y cómo preparar tu espacio de trabajo.'
  }, {
    title: 'Tomo 2 – Limpieza Profunda y Detailing Interior',
    description: 'Técnicas profesionales para plásticos, tapizados, cueros y eliminación de olores. Deja el interior como 0km.'
  }, {
    title: 'Tomo 3 – Corrección de Pintura y Pulido Profesional',
    description: 'El secreto mejor guardado: cómo eliminar rayas, marcas de agua y devolver el brillo espejo sin dañar la laca.'
  }, {
    title: 'Tomo 4 – Protección de Pintura y Acabados Profesionales',
    description: 'Ceras, selladores sintéticos y tratamientos cerámicos. Cómo aplicarlos correctamente para que duren meses.'
  }, {
    title: 'Tomo 5 – Cómo Ganar Dinero con Detailing Automotriz',
    description: 'Estrategias de negocio, cómo armar presupuestos, tratar con clientes y escalar tus ingresos.'
  }];
  return <section className="bg-[#0A1628] py-20 px-4 border-t border-[#1E3A5F]" data-id="element-138">
      <div className="max-w-4xl mx-auto" data-id="element-139">
        <div className="text-center mb-16" data-id="element-140">
          <h2 className="text-3xl md:text-5xl font-black text-white mb-4 uppercase" data-id="element-141">
            ¿Qué incluye el Método Detailing Pro?
          </h2>
          <p className="text-xl md:text-2xl text-[#B8860B] font-bold" data-id="element-142">
            El programa incluye 5 guías profesionales completas
          </p>
        </div>

        <div className="space-y-6" data-id="element-143">
          {guides.map((guide, index) => <div key={index} className="bg-[#132847] p-6 md:p-8 rounded-2xl shadow-sm border border-[#1E3A5F] flex flex-col md:flex-row gap-6 items-start hover:shadow-md hover:shadow-[#D4AF37]/10 hover:border-[#D4AF37]/50 transition-all" data-id="element-144">
              <div className="bg-gradient-to-br from-[#D4AF37] to-[#B8860B] w-16 h-16 rounded-xl flex items-center justify-center flex-shrink-0 shadow-lg" data-id="element-145">
                <BookOpen className="w-8 h-8 text-white" data-id="element-146" />
              </div>
              <div data-id="element-147">
                <h3 className="text-xl md:text-2xl font-bold text-white mb-3 flex items-center gap-2" data-id="element-148">
                  {guide.title}
                </h3>
                <p className="text-gray-400 text-lg" data-id="element-149">{guide.description}</p>
                <div className="mt-4 flex items-center gap-2 text-sm font-bold text-green-600 uppercase tracking-wider" data-id="element-150">
                  <CheckCircle2 className="w-5 h-5" data-id="element-151" />
                  Incluido en el Mega Pack
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}